import { render, staticRenderFns } from "./BankCardTab.vue?vue&type=template&id=19567d20&scoped=true"
import script from "./BankCardTab.vue?vue&type=script&lang=js"
export * from "./BankCardTab.vue?vue&type=script&lang=js"
import style0 from "./BankCardTab.vue?vue&type=style&index=0&id=19567d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19567d20",
  null
  
)

export default component.exports